interface AccordionState {
  isExpanded: boolean;
  defaultHeight: number;
}

function initAccordion(): void {
  const accordions = document.querySelectorAll<HTMLElement>('.c-accordion');

  if (accordions.length === 0) return;

  const accordionStates = new Map<HTMLElement, AccordionState>();
  const visibilityUpdaters: Array<() => void> = [];

  accordions.forEach((accordion) => {
    const wrapper = accordion.querySelector<HTMLElement>('.js-accordion-wrapper');
    const content = accordion.querySelector<HTMLElement>('.js-accordion-content');
    const button = accordion.querySelector<HTMLButtonElement>('.js-accordion-btn');
    const buttonText = button?.querySelector<HTMLElement>('.c-accordion__btn-text');

    if (!wrapper || !content || !button || !buttonText) return;

    // デフォルトの高さを取得（intro用は300px、それ以外は180px）
    const isIntro = content.classList.contains('c-accordion__content--intro');
    const defaultHeight = isIntro ? 300 : 180;

    // 状態を初期化
    accordionStates.set(accordion, {
      isExpanded: false,
      defaultHeight,
    });

    // 初期状態を設定
    const updateVisibility = () => {
      const state = accordionStates.get(accordion);
      if (!state) return;

      const isSmallScreen = window.innerWidth <= 768;
      const collapsedHeight = isSmallScreen ? state.defaultHeight : (isIntro ? 200 : 150);

      button.style.display = 'flex';

      if (state.isExpanded) {
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.classList.add('is-expanded');
        wrapper.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        buttonText.textContent = 'close';
      } else {
        content.style.maxHeight = `${collapsedHeight}px`;
        content.classList.remove('is-expanded');
        wrapper.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        buttonText.textContent = 'more';
      }
    };
    visibilityUpdaters.push(updateVisibility);

    // ボタンクリックでアコーディオン開閉
    button.addEventListener('click', () => {
      const state = accordionStates.get(accordion);
      if (!state) return;

      state.isExpanded = !state.isExpanded;

      const isSmallScreen = window.innerWidth <= 768;
      const collapsedHeight = isSmallScreen ? state.defaultHeight : (isIntro ? 200 : 150);

      if (state.isExpanded) {
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.classList.add('is-expanded');
        wrapper.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        buttonText.textContent = 'close';
      } else {
        content.style.maxHeight = `${collapsedHeight}px`;
        content.classList.remove('is-expanded');
        wrapper.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        buttonText.textContent = 'more';
      }
    });

    // 初期化
    updateVisibility();
  });

  // リサイズ時に表示を一括更新（debounce）
  let resizeTimer: number | undefined;
  window.addEventListener('resize', () => {
    if (resizeTimer !== undefined) {
      window.clearTimeout(resizeTimer);
    }
    resizeTimer = window.setTimeout(() => {
      visibilityUpdaters.forEach((updater) => updater());
    }, 150);
  });
}

export { initAccordion };
